var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 63.414 63.707",
    style: {
      enableBackground: "new 0 0 63.414 63.707"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "co-founder-business-entrepneur-startup"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.707,
    y: 8,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.707,
    y: 52.586,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -33.8762 26.2157)",
    width: 2,
    height: 2.828
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.414,41.293l-3-3c-0.192-0.193-0.468-0.31-0.727-0.293c-0.272,0.006-0.53,0.122-0.715,0.322l-0.108,0.275L48,37.586V35 c0-0.265-0.105-0.52-0.293-0.707L42,28.586V22c0-0.265-0.105-0.52-0.293-0.707L40,19.586V18c0,0,1-0.448,1-1v-4V-0.293h-2v12H25 v-12h-2V13v4c0,0.552,0,1,1,1v1.586l-3.707,3.707C20.105,23.48,20,23.735,20,24v2.586l-4.707,4.707C15.105,31.48,15,31.735,15,32 v5.586l-1.146,1l-0.366-0.293c-0.391-0.391-1.06-0.391-1.451,0l-3.018,3l-9.009,9l1.409,1.414l8.291-8.293L20.294,54l-8.294,8.293 l1.414,1.414l9-9l3-3c0.391-0.391,0.391-1.023,0-1.414L25.121,50l1.054-1.054C26.348,48.977,26.525,49,26.707,49 c0.395,0,0.77-0.081,1.116-0.22c0.346,1.275,1.501,2.22,2.884,2.22c1.065,0,1.997-0.709,2.529-1.548 c0.437,0.248,0.934,0.255,1.471,0.255h1.586l0.988,1.134l-0.308,0.407c-0.364,0.395-0.352,1.042,0.028,1.422l3,3.018l8,8.009 l1.414-1.409l-7.32-7.319l3.547-3.842l7.095-7.686L62,52.707l1.414-1.414L53.414,41.293z M39,13.707v2H25v-2H39z M21.707,52.586 L11.121,42l1.586-1.586L13,40.707l10,10L23.293,51L21.707,52.586z M15.121,40l1.439-1.293C16.748,38.52,17,38.265,17,38v-5.586l3-3 V31c0,0.265,0.105,0.52,0.293,0.707L24,35.414V46c0,0.722,0.12,1.375,0.546,1.894l-0.766,0.692L15.121,40z M34,47V31.707h-2V47v1 c0,0.551-0.449,1-1,1s-1-0.449-1-1v-2V31.707h-2V46c0,0.551-0.449,1-1,1s-1-0.449-1-1V29.707h-2v2.879l-2-2V28v-2v-1.586 l3.707-3.707C25.895,20.52,26,20.265,26,20v-2.293h12V20c0,0.265,0.105,0.52,0.293,0.707L40,22.414V42c0,0.551-0.449,1-1,1 s-1-0.449-1-1V31.707h-2V42v5c0,0.551-0.449,1-1,1S34,47.551,34,47z M37.414,48.293c-0.003-0.003,0.14-0.003,0.138-0.006 C37.74,47.896,38,47.463,38,47v-2.184C38,44.928,38.648,45,39,45c1.654,0,3-1.346,3-3V31.414l4,4V38 c0,0.265-0.041,0.52,0.146,0.707l1.252,1.326l-4.405,4.805l-4.338,4.679L37.414,48.293z M39.205,51.851 c0.086-0.051,0.173-0.103,0.241-0.178l5.006-5.507l5.283-5.723l1.584,1.585l-3.547,3.843l-7.095,7.686l-1.584-1.585L39.205,51.851z "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.293,
    y: 48,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -19.2107 51.6213)",
    width: 2.828,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.707,59c-3.34,0-6.581-0.647-9.634-1.924l-0.771,1.846C24.6,60.301,28.101,61,31.707,61 c2.836,0,5.631-0.438,8.307-1.302L39.4,57.794C36.923,58.594,34.334,59,31.707,59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.707,34c0,2.343-0.323,4.661-0.961,6.89l1.923,0.551c0.689-2.408,1.039-4.912,1.039-7.44 c0-10.441-6.114-20.047-15.576-24.471l-0.847,1.812C51.045,15.438,56.707,24.332,56.707,34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.624,40.731C7.015,38.551,6.707,36.286,6.707,34c0-9.668,5.662-18.562,14.423-22.659l-0.847-1.812 C10.821,13.953,4.707,23.559,4.707,34c0,2.468,0.333,4.913,0.99,7.268L7.624,40.731z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIcon);
export default __webpack_public_path__ + "static/media/teamIcon.83dadd4d85e5105eccf571530df45c41.svg";
export { ForwardRef as ReactComponent };